import React, { FC } from "react";

const Error: FC = () => {
  return <div>Error</div>;
};

export default Error;
